
import { getToken } from '@/utils/auth' // 验权
import { getUserInfoByToken, getPersonTagList } from '@/api/user'

const user = {
  state: {
    userInfo: {},
    tagList: []
  },
  mutations: {
    SET_USER_INFO: (state, data) => {
      state.userInfo = data
    },
    SET_TAG_LIST: (state, data) => {
      state.tagList = data
    }
  },
  actions: {
    getUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfoByToken(getToken()).then(res => {
          const data = res.result || {}
          commit('SET_USER_INFO', data)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getTagList ({ commit }) {
      return new Promise((resolve, reject) => {
        getPersonTagList().then(res => {
          const data = res.result || {}
          commit('SET_TAG_LIST', data)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default user
